// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".osui-card-compact .ant-card-head{border-bottom:0;font-size:14px}.osui-card-compact .ant-card-head .ant-card-extra,.osui-card-compact .ant-card-head .ant-card-head-title{padding:20px 0 0}.osui-card-compact .ant-card-body{padding-top:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
